import React from "react";
import "./detalleEmpleadoBank.css";

export default function DetalleEmpleadoBank({ datosBancarios = {} }) {
  const { cuentaNomina = {}, cuentaAdicional = {} } = datosBancarios;

  return (
    <div className="detalle-empleado-bank">
      <h5 className="mb-2">Datos Bancarios</h5>
      <div className="row g-4">
        {/* Nómina */}
        <div className="col-12 col-md-6">
          <div className="subsection">
            <h6 className="subsection-title">Nómina</h6>
            <div className="row g-2">
              <div className="col-12">
                <strong>Banco:</strong> {cuentaNomina.banco || "-"}
              </div>
              <div className="col-12">
                <strong>Titular:</strong> {cuentaNomina.titular || "-"}
              </div>
              <div className="col-12">
                <strong>CLABE:</strong> {cuentaNomina.clabe || "-"}
              </div>
            </div>
          </div>
        </div>

        {/* Adicional */}
        <div className="col-12 col-md-6">
          <div className="subsection">
            <h6 className="subsection-title">Adicional</h6>
            <div className="row g-2">
              <div className="col-12">
                <strong>Banco:</strong> {cuentaAdicional.banco || "-"}
              </div>
              <div className="col-12">
                <strong>Titular:</strong> {cuentaAdicional.titular || "-"}
              </div>
              <div className="col-12">
                <strong>CLABE:</strong> {cuentaAdicional.clabe || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
